module.exports = __webpack_public_path__ + "static/media/user-headset.0c3ab744.svg";